import e, { Component as t } from "react";
import o from "../../../../node_modules/classnames/index.js";
import n from "../../../utils/DomHandler.js";
import i from "../../../utils/ObjectUtils.js";
import { OverlayService as l } from "./OverlayService/OverlayService.js";
import { RadioButton as a } from "../../forms/RadioButton/RadioButton.js";
import { CheckBox as r } from "../../forms/Checkbox/Checkbox.js";
import { Ripple as s } from "../../forms/Ripple/Ripple.js";
import { isSpacebar as p } from "../../../constants/keyboard.js";
import { Icon as c } from "../Icon/Icon.js";
function d(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function u(e, t) {
  for (var o = 0; o < t.length; o++) {
    var n = t[o];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function h(e, t, o) {
  return t in e ? Object.defineProperty(e, t, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = o, e;
}
function f(e) {
  return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function m(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {},
      n = Object.keys(o);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function (e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    }))), n.forEach(function (t) {
      h(e, t, o[t]);
    });
  }
  return e;
}
function b(e, t) {
  return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : function (e, t) {
    var o = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      o.push.apply(o, n);
    }
    return o;
  }(Object(t)).forEach(function (o) {
    Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
  }), e;
}
function g(e, t) {
  return (g = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var w = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && g(e, t);
  }(x, t);
  var w,
    v,
    C,
    y = (w = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        o = f(x);
      if (w) {
        var n = f(this).constructor;
        t = Reflect.construct(o, arguments, n);
      } else t = o.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : d(this);
    });
  function x() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, x), e = y.apply(this, arguments), h(d(e), "keyHelper", void 0), h(d(e), "overlayEventListener", void 0), h(d(e), "el", void 0), h(d(e), "tabindexTimeout", void 0), h(d(e), "state", {
      editing: e.props.editing,
      editingRowData: e.props.rowData,
      styleObject: {},
      mouseOver: !1
    }), h(d(e), "getCellCallbackParams", function (t) {
      return {
        originalEvent: t,
        value: null,
        field: e.field,
        rowData: e.props.rowData,
        rowIndex: e.props.rowIndex,
        cellIndex: e.props.index,
        selected: e.isSelected(),
        column: e.props.column,
        props: e.props
      };
    }), h(d(e), "onCellEditChange", function (t) {
      var o = m({}, e.state.editingRowData);
      o[e.field] = t, e.setState({
        editingRowData: o
      }), e.props.editingMeta[e.props.rowIndex].data[e.field] = t;
    }), h(d(e), "onCellEditCommit", function (t) {
      e.switchCellToViewMode(t, !0);
    }), h(d(e), "onCellEditCancel", function (t) {
      e.switchCellToViewMode(t, !1);
    }), h(d(e), "onClick", function (t) {
      var o = e.getCellCallbackParams(t);
      if ("row" !== e.props.editMode && e.isEditable() && !e.state.editing && (e.props.selectOnEdit || !e.props.selectOnEdit && e.props.selected)) {
        var n = e.getColumnProp("onBeforeCellEditShow"),
          i = e.getColumnProp("onCellEditInit");
        n && n(o), setTimeout(function () {
          e.setState({
            editing: !0
          }, function () {
            i && i(o);
          });
        }, 1);
      }
      e.props.allowCellSelection && e.props.onClick && e.props.onClick(o);
    }), h(d(e), "onMouseDown", function (t) {
      var o = e.getCellCallbackParams(t);
      e.props.onMouseDown && e.props.onMouseDown(o);
    }), h(d(e), "onMouseUp", function (t) {
      var o = e.getCellCallbackParams(t);
      e.props.onMouseUp && e.props.onMouseUp(o);
    }), h(d(e), "onMouseEnter", function () {
      e.getColumnProp("editor") && "cell" === e.props.editMode && e.setState({
        mouseOver: !0
      });
    }), h(d(e), "onMouseLeave", function () {
      e.getColumnProp("editor") && "cell" === e.props.editMode && e.setState({
        mouseOver: !1
      });
    }), h(d(e), "onBlur", function (t) {
      "cell" !== e.props.editMode || n.hasClass(t.relatedTarget, "inline-editor__apply-button") || e.onCellEditCancel(t);
    }), h(d(e), "onKeyDown", function (t) {
      if (e.props.allowCellSelection) {
        var o = t.target,
          i = t.currentTarget;
        switch (t.which) {
          case 37:
            var l = e.findPrevSelectableCell(i);
            l && (e.changeTabIndex(i, l), l.focus()), t.preventDefault();
            break;
          case 39:
            var a = e.findNextSelectableCell(i);
            a && (e.changeTabIndex(i, a), a.focus()), t.preventDefault();
            break;
          case 38:
            var r = e.findPrevSelectableRow(i.parentElement);
            if (r) {
              var s = r.children[e.props.index];
              e.changeTabIndex(i, s), s.focus();
            }
            t.preventDefault();
            break;
          case 40:
            var p = e.findNextSelectableRow(i.parentElement);
            if (p) {
              var c = p.children[e.props.index];
              e.changeTabIndex(i, c), c.focus();
            }
            t.preventDefault();
            break;
          case 13:
            n.isClickable(o) || (e.onClick(t), t.preventDefault());
            break;
          case 32:
            n.isClickable(o) || o.readOnly || (e.onClick(t), t.preventDefault());
        }
      }
    }), h(d(e), "onEditorFocus", function (t) {
      e.onClick(t);
    }), h(d(e), "onRowToggle", function (t) {
      e.props.onRowToggle({
        originalEvent: t,
        data: e.props.rowData
      }), t.preventDefault();
    }), h(d(e), "onRowEditInit", function (t) {
      e.props.onRowEditInit({
        originalEvent: t,
        data: e.props.rowData,
        newData: e.getEditingRowData(),
        field: e.field,
        index: e.props.rowIndex
      });
    }), h(d(e), "onRowEditSave", function (t) {
      e.props.onRowEditSave({
        originalEvent: t,
        data: e.props.rowData,
        newData: e.getEditingRowData(),
        field: e.field,
        index: e.props.rowIndex
      });
    }), h(d(e), "onRowEditCancel", function (t) {
      e.props.onRowEditCancel({
        originalEvent: t,
        data: e.props.rowData,
        newData: e.getEditingRowData(),
        field: e.field,
        index: e.props.rowIndex
      });
    }), h(d(e), "onRadioChange", function (t, o) {
      e.props.onRadioChange({
        originalEvent: o,
        data: e.props.rowData
      });
    }), h(d(e), "onCheckboxChange", function (t, o) {
      e.props.onCheckboxChange({
        originalEvent: o,
        data: e.props.rowData
      });
    }), h(d(e), "onRadioKeyDown", function (t) {
      p(t) && (e.props.onRadioChange({
        originalEvent: t,
        data: e.props.rowData
      }), t.preventDefault());
    }), h(d(e), "onCheckboxKeyDown", function (t) {
      p(t) && (e.props.onCheckboxChange({
        originalEvent: t,
        data: e.props.rowData
      }), t.preventDefault());
    }), e;
  }
  return v = [{
    key: "field",
    get: function get() {
      return this.getColumnProp("field") || "field_".concat(this.props.index);
    }
  }, {
    key: "isEditable",
    value: function value() {
      return this.getColumnProp("editor");
    }
  }, {
    key: "getVirtualScrollerOption",
    value: function value(e) {
      return this.props.virtualScrollerOptions ? this.props.virtualScrollerOptions[e] : null;
    }
  }, {
    key: "isSelected",
    value: function value() {
      return !!this.props.selection && (this.props.selection instanceof Array ? this.findIndex(this.props.selection) > -1 : this.equals(this.props.selection));
    }
  }, {
    key: "equalsData",
    value: function value(e) {
      return "equals" === this.props.compareSelectionBy ? e === this.props.rowData : i.equals(e, this.props.rowData, this.props.dataKey);
    }
  }, {
    key: "equals",
    value: function value(e) {
      return (e.rowIndex === this.props.rowIndex || this.equalsData(e.rowData)) && (e.field === this.field || e.cellIndex === this.props.index);
    }
  }, {
    key: "isOutsideClicked",
    value: function value(e) {
      return this.el && !(this.el.isSameNode(e) || this.el.contains(e));
    }
  }, {
    key: "getColumnProp",
    value: function value(e) {
      return this.props.column ? this.props.column.props[e] : null;
    }
  }, {
    key: "getStyle",
    value: function value() {
      var e = this.getColumnProp("bodyStyle"),
        t = this.getColumnProp("style");
      return this.getColumnProp("frozen") ? Object.assign({}, t, e, this.state.styleObject) : Object.assign({}, t, e);
    }
  }, {
    key: "resolveFieldData",
    value: function value(e) {
      return i.resolveFieldData(e || this.props.rowData, this.field);
    }
  }, {
    key: "getEditingRowData",
    value: function value() {
      return this.props.editingMeta && this.props.editingMeta[this.props.rowIndex] ? this.props.editingMeta[this.props.rowIndex].data : this.props.rowData;
    }
  }, {
    key: "getTabIndex",
    value: function value(e) {
      return this.props.allowCellSelection ? e ? 0 : 0 === this.props.rowIndex && 0 === this.props.index ? this.props.tabIndex : -1 : null;
    }
  }, {
    key: "findIndex",
    value: function value(e) {
      var t = this;
      return (e || []).findIndex(function (e) {
        return t.equals(e);
      });
    }
  }, {
    key: "closeCell",
    value: function value(e) {
      var t = this,
        o = this.getCellCallbackParams(e),
        n = this.getColumnProp("onBeforeCellEditHide");
      n && n(o), setTimeout(function () {
        t.setState({
          editing: !1
        });
      }, 1);
    }
  }, {
    key: "switchCellToViewMode",
    value: function value(e, t) {
      var o = this.getCellCallbackParams(e),
        n = this.state.editingRowData,
        i = this.resolveFieldData(n),
        l = b(m({}, o), {
          newRowData: n,
          newValue: i
        }),
        a = this.getColumnProp("onCellEditCancel"),
        r = this.getColumnProp("cellEditValidator"),
        s = this.getColumnProp("onCellEditComplete");
      !t && a && a(l);
      var p = !0;
      r && (p = r(l)), p ? (t && s && s(l), this.closeCell(e)) : e.preventDefault();
    }
  }, {
    key: "findNextSelectableCell",
    value: function value(e) {
      var t = e.nextElementSibling;
      return t ? n.hasClass(t, "datatable__cell--selectable") ? t : this.findNextSelectableRow(t) : null;
    }
  }, {
    key: "findPrevSelectableCell",
    value: function value(e) {
      var t = null == e ? void 0 : e.previousElementSibling;
      return t ? n.hasClass(t, "datatable__cell--selectable") ? t : this.findPrevSelectableRow(t) : null;
    }
  }, {
    key: "findNextSelectableRow",
    value: function value(e) {
      var t = e.nextElementSibling;
      return t ? n.hasClass(t, "datatable__row--selectable") ? t : this.findNextSelectableRow(t) : null;
    }
  }, {
    key: "findPrevSelectableRow",
    value: function value(e) {
      var t = null == e ? void 0 : e.previousElementSibling;
      return t ? n.hasClass(t, "datatable__row--selectable") ? t : this.findPrevSelectableRow(t) : null;
    }
  }, {
    key: "changeTabIndex",
    value: function value(e, t) {
      e && t && (e.tabIndex = -1, t.tabIndex = this.props.tabIndex);
    }
  }, {
    key: "focusOnElement",
    value: function value() {
      var e = this;
      clearTimeout(this.tabindexTimeout), this.tabindexTimeout = setTimeout(function () {
        if (e.state.editing) {
          var t = n.getFirstFocusableElement(e.el, ":not(.datatable__cell-editor-key-helper)");
          t && t.focus();
        }
        e.keyHelper && (e.keyHelper.tabIndex = e.state.editing ? -1 : 0);
      }, 1);
    }
  }, {
    key: "updateStickyPosition",
    value: function value() {
      if (this.getColumnProp("frozen")) {
        var e = m({}, this.state.styleObject);
        if ("right" === this.getColumnProp("alignFrozen")) {
          var t = 0,
            o = this.el.nextElementSibling;
          o && (t = n.getOuterWidth(o) + parseFloat(o.style.right)), e.right = t + "px";
        } else {
          var i,
            l = 0,
            a = null === (i = this.el) || void 0 === i ? void 0 : i.previousElementSibling;
          a && (l = n.getOuterWidth(a) + parseFloat(a.style.left)), e.left = l + "px";
        }
        this.state.styleObject.left === e.left && this.state.styleObject.right === e.right || this.setState({
          styleObject: e
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.getColumnProp("frozen") && this.updateStickyPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e, t) {
      if (this.getColumnProp("frozen") && this.updateStickyPosition(), ("cell" === this.props.editMode || "row" === this.props.editMode) && (this.focusOnElement(), e.editingMeta !== this.props.editingMeta && this.setState({
        editingRowData: this.getEditingRowData()
      }), t.editing !== this.state.editing)) {
        var o,
          n,
          i = b(m({}, this.getCellCallbackParams()), {
            editing: this.state.editing
          });
        null === (o = (n = this.props).onEditingMetaChange) || void 0 === o || o.call(n, i);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.overlayEventListener && (l.off("overlay-click", this.overlayEventListener), this.overlayEventListener = null);
    }
  }, {
    key: "renderLoading",
    value: function value() {
      var t = this.getVirtualScrollerOption("getLoaderOptions")(this.props.rowIndex, {
          cellIndex: this.props.index,
          cellFirst: 0 === this.props.index,
          cellLast: this.props.index === this.getVirtualScrollerOption("columns").length - 1,
          cellEven: this.props.index % 2 == 0,
          cellOdd: this.props.index % 2 != 0,
          column: this.props.column,
          field: this.field
        }),
        o = i.getJSXElement(this.getVirtualScrollerOption("loadingTemplate"), t);
      return e.createElement("td", {
        className: "datatable__cell datatable__cell--body"
      }, o);
    }
  }, {
    key: "renderElement",
    value: function value() {
      var t,
        n,
        l,
        p = this,
        d = this.props.allowCellSelection && this.isSelected(),
        u = "row" === this.props.editMode,
        f = this.getTabIndex(d),
        m = this.getColumnProp("selectionMode"),
        b = this.getColumnProp("rowReorder"),
        g = this.getColumnProp("expander"),
        w = this.getColumnProp("rowEditor"),
        v = this.getColumnProp("header"),
        C = this.getColumnProp("body"),
        y = this.getColumnProp("editor"),
        x = this.getColumnProp("frozen"),
        E = this.resolveFieldData(),
        k = i.getPropValue(this.props.cellClassName, E, {
          props: this.props.tableProps,
          rowData: this.props.rowData
        }),
        _ = o("datatable__cell datatable__cell--body", this.getColumnProp("bodyClassName"), this.getColumnProp("class"), k, h({
          "datatable__column--selectable": m,
          "datatable__column--editable-row": y && "row" === this.props.editMode,
          "datatable__column--editable-cell": y && "cell" === this.props.editMode,
          "datatable__column--row-editor": w,
          "datatable__cell--hover": y && (this.state.editing || this.state.mouseOver),
          "datatable__cell--editing": y && this.state.editing,
          "datatable__column--frozen": x,
          "datatable__column--row-reorder": b,
          "datatable__cell--selectable": this.props.allowCellSelection && this.props.selectable,
          "datatable__cell--selected": d
        }, "datatable__cell--".concat(this.getColumnProp("dataType")), this.getColumnProp("dataType"))),
        D = this.getStyle(),
        S = "stack" === this.props.responsiveLayout && e.createElement("span", {
          className: "datatable__column-title"
        }, i.getJSXElement(v, {
          props: this.props.tableProps
        }));
      if (C && !this.state.editing) t = C ? i.getJSXElement(C, this.props.rowData, {
        column: this.props.column,
        field: this.field,
        rowIndex: this.props.rowIndex,
        frozenRow: this.props.frozenRow,
        props: this.props.tableProps
      }) : E;else if (y && (this.state.editing || this.state.mouseOver)) {
        var P = {
          value: this.resolveFieldData(this.state.editingRowData),
          onChange: this.onCellEditChange,
          onCommit: this.onCellEditCommit,
          onCancel: this.onCellEditCancel,
          editing: this.state.editing
        };
        t = i.getJSXElement(y, P);
      } else if (m) t = e.createElement(e.Fragment, null, "single" === m && e.createElement(a, {
        className: "datatable__radio-button",
        name: "".concat(this.props.tableSelector, "radio-button"),
        checked: this.props.selected,
        onChange: this.onRadioChange,
        onKeyDown: this.onRadioKeyDown,
        disabled: !this.props.selectable
      }), "multiple" === m && e.createElement(r, {
        className: "datatable__checkbox",
        name: "".concat(this.props.tableSelector, "checkbox"),
        value: this.props.selected,
        onChange: this.onCheckboxChange,
        onKeyDown: this.onCheckboxKeyDown,
        disabled: !this.props.selectable
      }));else if (b) t = (!this.props.showRowReorderElement || this.props.showRowReorderElement(this.props.rowData, {
        rowIndex: this.props.rowIndex,
        props: this.props.tableProps
      })) && e.createElement(c, {
        className: "datatable__row-reorder-handle",
        name: "grip-vertical",
        solid: !0
      });else if (g) {
        var O = o("datatable__row-toggler-icon", this.props.expanded ? this.props.expandedRowIcon : this.props.collapsedRowIcon),
          I = "".concat(this.props.tableSelector, "_content_").concat(this.props.rowIndex, "_expanded"),
          R = {
            onClick: this.onRowToggle,
            className: "datatable__row-toggler p-link",
            iconClassName: O
          };
        t = e.createElement("button", {
          className: R.className,
          onClick: R.onClick,
          type: "button",
          "aria-expanded": this.props.expanded,
          "aria-controls": I,
          tabIndex: this.props.tabIndex
        }, e.createElement("span", {
          className: R.iconClassName
        }), e.createElement(s, null)), C && (R.element = t, t = i.getJSXElement(C, this.props.rowData, {
          column: this.props.column,
          field: this.field,
          rowIndex: this.props.rowIndex,
          frozenRow: this.props.frozenRow,
          props: this.props.tableProps,
          expander: R
        }));
      } else u && w ? (this.state.editing ? (l = {
        editing: !0,
        onSaveClick: this.onRowEditSave,
        saveIconClassName: "datatable__row-editor-save",
        onCancelClick: this.onRowEditCancel,
        cancelIconClassName: "datatable__row-editor-cancel"
      }, t = e.createElement("div", {
        className: "datatable__row-editor-wrapper"
      }, e.createElement(c, {
        name: "check",
        regular: !0,
        onClick: l.onSaveClick,
        className: l.saveIconClassName,
        tabIndex: this.props.tabIndex
      }), e.createElement(c, {
        name: "times",
        regular: !0,
        onClick: l.onCancelClick,
        className: l.cancelIconClassName,
        tabIndex: this.props.tabIndex
      }))) : (l = {
        editing: !1,
        onInitClick: this.onRowEditInit,
        initClassName: "datatable__row-editor-init",
        initIconClassName: "datatable__row-editor-init-icon"
      }, t = e.createElement("div", {
        className: "datatable__row-editor-wrapper"
      }, e.createElement(c, {
        name: "pen-to-square",
        regular: !0,
        onClick: l.onInitClick,
        className: l.initClassName,
        tabIndex: this.props.tabIndex
      }))), C && (l.element = t, t = i.getJSXElement(C, this.props.rowData, {
        column: this.props.column,
        field: this.field,
        rowIndex: this.props.rowIndex,
        frozenRow: this.props.frozenRow,
        props: this.props.tableProps,
        rowEditor: l
      }))) : t = E;
      return !u && y && (n = e.createElement("a", {
        tabIndex: 0,
        ref: function ref(e) {
          return p.keyHelper = e;
        },
        className: "datatable__cell-editor-key-helper p-hidden-accessible",
        onFocus: this.onEditorFocus
      }, e.createElement("span", null))), e.createElement("td", {
        ref: function ref(e) {
          return p.el = e;
        },
        style: D,
        className: _,
        rowSpan: this.props.rowSpan,
        tabIndex: f,
        role: "cell",
        onClick: this.onClick,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, n, S, t);
    }
  }, {
    key: "render",
    value: function value() {
      return this.getVirtualScrollerOption("loading") ? this.renderLoading() : this.renderElement();
    }
  }], C = [{
    key: "getDerivedStateFromProps",
    value: function value(e, t) {
      return "row" === e.editMode && e.editing !== t.editing ? {
        editing: e.editing
      } : null;
    }
  }], v && u(x.prototype, v), C && u(x, C), x;
}(t);
h(w, "defaultProps", {
  selectable: !0
});
export { w as BodyCell };